var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgQualityIcon = function SvgQualityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "quality-icon_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4797"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2507"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 25",
    d: "M19.333 27.792H6.042A6.049 6.049 0 010 21.75V6.042A6.049 6.049 0 016.042 0h13.291a6.049 6.049 0 016.042 6.042V21.75a6.049 6.049 0 01-6.042 6.042zM12.469 8.675v9.45h3.109a4.4 4.4 0 002.223-.587 4.035 4.035 0 001.544-1.61 4.884 4.884 0 00.549-2.327v-.43a4.859 4.859 0 00-.568-2.32 4.014 4.014 0 00-1.564-1.607 4.485 4.485 0 00-2.252-.569zm-7.06 5.5h3.355v3.946h2.266V8.675H8.764v3.745H5.409V8.675H3.131v9.45h2.278V14.18zm10.131 2.194h-.8v-5.935h.766a1.813 1.813 0 011.532.694 3.41 3.41 0 01.526 2.064v.408a3.439 3.439 0 01-.526 2.074 1.781 1.781 0 01-1.5.7z",
    transform: "translate(6.625 4)",
    fill: "url(#quality-icon_svg__a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2505"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2506"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 734",
    transform: "translate(3 4)",
    stroke: "#000",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 28,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 27,
    rx: 4.5
  }))))))));
};
export default SvgQualityIcon;